{
  "version": 1,
  "asset_id": "a421c300-5d8a-49ad-bcec-5de288ba916c",
  "project_id": "7948fbe6-b4e3-485f-995c-f8f53bd7ab6b",
  "url": "/__l5e/assets-v1/a421c300-5d8a-49ad-bcec-5de288ba916c/arwen-aft-helideck.png",
  "r2_key": "a/v1/7948fbe6-b4e3-485f-995c-f8f53bd7ab6b/a421c300-5d8a-49ad-bcec-5de288ba916c/arwen-aft-helideck.png",
  "original_filename": "arwen-aft-helideck.png",
  "size": 1408093,
  "content_type": "image/png",
  "created_at": "2026-07-05T03:27:38Z"
}
